import { render, staticRenderFns } from "./MetamaskAccountPicker.vue?vue&type=template&id=c0c9915c&"
import script from "./MetamaskAccountPicker.vue?vue&type=script&lang=js&"
export * from "./MetamaskAccountPicker.vue?vue&type=script&lang=js&"
import style0 from "./MetamaskAccountPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports